(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('slider-component')) {
    class SliderComponent extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.slider');
        this.slides = this.querySelectorAll('.slider__slide');
        if (!this.slider || this.slides.length === 0) return;

        this.prevButton = this.querySelector('.slider-button--prev');
        this.nextButton = this.querySelector('.slider-button--next');
        this.paginationDots = this.querySelectorAll('.slider-counter__link');
        this.currentPage = 0;
        this.slideWidth = 0; // Initialize to 0
        
        // Use a timeout to ensure correct width calculation after potential layout shifts
        setTimeout(() => {
            if (this.slides[0]) {
              this.slideWidth = this.slides[0].clientWidth;
            }
            // Failsafe in case clientWidth is 0 (e.g., element is hidden)
            if (this.slideWidth === 0 && this.slider.clientWidth > 0) {
              this.slideWidth = this.slider.clientWidth;
            }

            // Only initialize pagination and autoplay *after* width is known
            if (this.slideWidth > 0) {
              this.updatePagination();
              this.initAutoplay();
            }
        }, 100);

        this.onScroll = this.onScroll.bind(this);
        this.slider.addEventListener('scroll', this.onScroll);

        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => this.scrollPrevious());
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => this.scrollNext());
        }

        this.paginationDots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.scrollToSlide(index));
        });

        // Recalculate width on resize
        this.resizeObserver = new ResizeObserver(entries => {
            if (entries[0] && this.slides[0]) {
                this.slideWidth = this.slides[0].clientWidth;
                // Failsafe
                if (this.slideWidth === 0 && this.slider.clientWidth > 0) {
                  this.slideWidth = this.slider.clientWidth;
                }
                this.scrollToSlide(this.currentPage, 'auto'); // Snap to current slide on resize
            }
        });
        
        this.resizeObserver.observe(this.slider);

        // Defer pagination update and autoplay init until width is calculated
      }

      onScroll() {
        if (this.slideWidth === 0) return; // Failsafe
        const scrollLeft = this.slider.scrollLeft;
        this.currentPage = Math.round(scrollLeft / this.slideWidth);
        this.updatePagination();
      }

      scrollNext() {
        let targetPage = this.currentPage + 1;
        if (targetPage >= this.slides.length) {
          targetPage = 0; // Loop back to start
        }
        this.scrollToSlide(targetPage);
      }

      scrollPrevious() {
        let targetPage = this.currentPage - 1;
        if (targetPage < 0) {
          targetPage = this.slides.length - 1; // Loop to end
        }
        this.scrollToSlide(targetPage);
      }

      scrollToSlide(index, behavior = 'smooth') {
        if (this.slides[index]) {
          this.slider.scrollTo({
            left: this.slides[index].offsetLeft,
            behavior: behavior
          });
          this.currentPage = index;
          this.updatePagination();
        }
      }

      updatePagination() {
        this.paginationDots.forEach((dot, index) => {
          if (index === this.currentPage) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
        
        // For a looping slider, buttons are never disabled
        if (this.prevButton) this.prevButton.disabled = false;
        if (this.nextButton) this.nextButton.disabled = false;
      }
      
      initAutoplay() {
        if (!this.dataset.autoplay || this.dataset.autoplay === 'false') return;
        
        const speed = this.dataset.speed ? parseInt(this.dataset.speed, 10) : 5000;
        
        const startAutoplay = () => {
          this.autoplayInterval = setInterval(() => {
            this.scrollNext();
          }, speed);
        }

        startAutoplay();
        
        // Pause on hover
        this.addEventListener('mouseenter', () => clearInterval(this.autoplayInterval));
        this.addEventListener('mouseleave', () => startAutoplay());
        // Pause on focus
        this.addEventListener('focusin', () => clearInterval(this.autoplayInterval));
        this.addEventListener('focusout', () => startAutoplay());
      }
    }
    customElements.define('slider-component', SliderComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
